/* Maintenance, App version & Build number check Using Response Interceptor */
import Axios from 'axios'

import keys from '@/config/keys'
import store from '@/redux/store'
import { setCurrentMixData } from '@/redux/slices/currentMixDataSlice'
import { LOCAL_BUILD_NUMBER, LOCAL_VERSION_NUMBER } from '@/config/vars'

const { VERSION, BUILD, INIT_APP_BUILD_NUMBER_KEY } = keys

export default () => {
	// Interceptor for handling 503 responses
	Axios.interceptors.response.use(
		(response) => {
			return response
		},
		(error) => {
			const statusCode = error?.response?.status
			// Check if the response status is 503
			if (statusCode === 503) {
				// Invoke the maintenance check function
				checkMaintenance()
			}
			return Promise.reject(error)
		},
	)

	// Interceptor for checking headers for all responses
	Axios.interceptors.response.use(
		(response) => {
			// Run a specific function to check headers
			checkHeaders(response.headers)
			return response
		},
		(error) => {
			return Promise.reject(error)
		},
	)
}

// Function to check maintenance
function checkMaintenance() {
	// Implement your logic to handle maintenance here
	console.log('% Maintenance check triggered %')
	const el = document.getElementById(keys.MAINTENANCE_MODAL_TRIGGER_BTN_ID)
	el && el.click()
}

// Function to check headers
function checkHeaders(headers) {
	const currentBuildNumber = LOCAL_BUILD_NUMBER
	const currentVersionNumber = LOCAL_VERSION_NUMBER

	if (!currentVersionNumber) return

	const {
		build: newBuildNumber,
		version: newVersionNumber,
		maintenanceEta,
		maintenancePeriod,
	} = getAppStaticDataFromHeader(headers)

	if (maintenanceEta) {
		store.dispatch(setCurrentMixData({ maintenanceEta }))
		window[keys.APP_MAINTENANCE_ETA_KEY] = maintenanceEta
		window[keys.APP_MAINTENANCE_PERIOD_KEY] = maintenancePeriod

		const lastOne = localStorage.getItem(keys.UPCOMING_MAINTENANCE_MODAL_CLOSED_FOR)

		if (lastOne && lastOne === maintenanceEta) {
			// User already seen it and pressed ok
		} else {
			const el = document.getElementById(keys.UPCOMING_MAINTENANCE_MODAL_TRIGGER_BTN_ID)
			el && el.click()
		}
	}

	const checkedVersion = window[keys.VERSION_UPDATE_CHECKED_KEY]
	const checkedBuild = window[keys.BUILD_UPDATE_CHECKED_KEY]
	const lastChecked = window[keys.LAST_UPDATE_CHECKED_TIMESTAMP_KEY]

	const openPopup = () => {
		const el = document.getElementById(keys.APP_LEVEL_UPDATE_MODAL_TRIGGER_BTN_ID)
		el && el.click()
	}

	const getOkayStatus = (to) => {
		const checkTimestamp = () => {
			let okay = false // User ignored this update already, so check if 5min passed
			if (lastChecked) {
				const currentTimestamp = new Date().valueOf()
				const FIVE_MIN = 5 * 60 * 1000
				if (currentTimestamp - Number(lastChecked) > FIVE_MIN) {
					okay = true // if 5min passed check popup again
				}
			}
			return okay
		}

		let okay = true

		if (to === VERSION) {
			if (newVersionNumber === checkedVersion) {
				okay = checkTimestamp()
			}
		} else if (to === BUILD) {
			if (newBuildNumber === checkedBuild) {
				okay = checkTimestamp()
			}
		}

		return okay
	}

	if (
		Number(newBuildNumber) >
		Number(sessionStorage.getItem(INIT_APP_BUILD_NUMBER_KEY) || currentBuildNumber.toString())
	) {
		const okay = getOkayStatus(BUILD)

		if (okay) {
			window[keys.APP_UPDATE_TYPE_KEY] = BUILD
			window[keys.BUILD_NUMBER_PROCESSING_KEY] = newBuildNumber // Just for data passing
			sessionStorage.setItem(INIT_APP_BUILD_NUMBER_KEY, newBuildNumber)
			openPopup()
		}
	}

	if (newBuildNumber === currentBuildNumber.toString()) {
		sessionStorage.removeItem(INIT_APP_BUILD_NUMBER_KEY)
	}
}

export const getAppStaticDataFromHeader = (_headers) => {
	const headers = _headers ?? {}
	return {
		build: headers[keys.HEADERS.API_APP_BUILD] ?? headers[keys.HEADERS.API_APP_BUILD.toLowerCase()],
		version:
			headers[keys.HEADERS.API_APP_VERSION] ?? headers[keys.HEADERS.API_APP_VERSION.toLowerCase()],
		maintenanceEta:
			headers[keys.HEADERS.API_APP_MAINTENANCE_ETA] ??
			headers[keys.HEADERS.API_APP_MAINTENANCE_ETA.toLowerCase()],
		maintenancePeriod:
			headers[keys.HEADERS.API_APP_MAINTENANCE_PERIOD] ??
			headers[keys.HEADERS.API_APP_MAINTENANCE_PERIOD.toLowerCase()],
	}
}
